import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsCivilStatusOtherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsCivilStatusShared isOther scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusOtherPage.displayName =
  'Research Family Notifications CivilStatusOtherPage component';

export default ResearchFamilyNotificationsCivilStatusOtherPage;
